import { Stack } from "@mui/material";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

export function DisputeConfirmationStep() {
  return (
    <Stack
      spacing={8}
      sx={{
        display: "flex",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Illustration type="check" />

      <Text semibold variant="h5">
        Thank you for submitting your dispute
      </Text>

      <Text sx={(theme) => ({ color: theme.palette.text.tertiary })}>
        We&apos;ll review your dispute and get back to you in 1 business day.
      </Text>
    </Stack>
  );
}
